import { useQuery } from '@tanstack/react-query';
import type { RegistryAccess } from '@mnc/contracts';
import { api } from './api';

/** What this instance may do with the master registry (phase-3-scope §3.4): the link controls show only when central answered with a grant. */
export function useRegistryAccess() {
  const q = useQuery({ queryKey: ['registry', 'access'], queryFn: () => api.get<RegistryAccess>('/api/registry/access'), staleTime: 60_000, retry: false });
  const access = q.data;
  return {
    loading: q.isLoading,
    available: Boolean(access?.available),
    configured: Boolean(access?.configured),
    canLink: (regionCode: string | null | undefined): boolean => Boolean(access?.grants.some((g) => (g.scope === 'link' || g.scope === 'propose') && (g.region_code === '*' || g.region_code === regionCode))),
    canPropose: Boolean(access?.grants.some((g) => g.scope === 'propose')),
    grants: access?.grants ?? [],
  };
}
